import * as z from "zod";

export const getOutlookConversation = {
  name: "getOutlookConversation" as const,
  input: z.object({ integrationId: z.string(), conversationId: z.string() }),
  output: z.object({ messages: z.array(z.record(z.string(), z.unknown())) }),
};
